module.exports = __webpack_public_path__ + "img/online-marker.260acbaa.svg";